(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["enhanced-header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement{constructor(){super()}connectedCallback(){this.header=document.querySelector('.section-header');this.headerIsAlwaysSticky=this.getAttribute('data-sticky-type')==='always'||this.getAttribute('data-sticky-type')==='reduce-logo-size';this.headerBounds={};this.setHeaderHeight();window.matchMedia('(max-width: 990px)').addEventListener('change',this.setHeaderHeight.bind(this));if(this.headerIsAlwaysSticky){this.header.classList.add('shopify-section-header-sticky')}this.currentScrollTop=0;this.preventReveal=false;this.predictiveSearch=this.querySelector('predictive-search');this.onScrollHandler=this.onScroll.bind(this);this.hideHeaderOnScrollUp=()=>this.preventReveal=true;this.addEventListener('preventHeaderReveal',this.hideHeaderOnScrollUp);window.addEventListener('scroll',this.onScrollHandler,false);this.createObserver()}setHeaderHeight(){document.documentElement.style.setProperty('--header-height',`${this.header.offsetHeight}px`)}disconnectedCallback(){this.removeEventListener('preventHeaderReveal',this.hideHeaderOnScrollUp);window.removeEventListener('scroll',this.onScrollHandler)}createObserver(){let e=new IntersectionObserver((e,t)=>{this.headerBounds=e[0].intersectionRect,t.disconnect()});e.observe(this.header)}onScroll(){const e=window.pageYOffset||document.documentElement.scrollTop;if(this.predictiveSearch&&this.predictiveSearch.isOpen)return;e>this.currentScrollTop&&e>this.headerBounds.bottom?(this.header.classList.add('scrolled-past-header'),this.preventHide||requestAnimationFrame(this.hide.bind(this))):e<this.currentScrollTop&&e>this.headerBounds.bottom?(this.header.classList.add('scrolled-past-header'),this.preventReveal? (window.clearTimeout(this.isScrolling),this.isScrolling=setTimeout(()=>{this.preventReveal=false},66),requestAnimationFrame(this.hide.bind(this))):requestAnimationFrame(this.reveal.bind(this))):e<=this.headerBounds.top&&(this.header.classList.remove('scrolled-past-header'),requestAnimationFrame(this.reset.bind(this)));this.currentScrollTop=e}hide(){if(this.headerIsAlwaysSticky)return;this.header.classList.add('shopify-section-header-hidden','shopify-section-header-sticky'),this.closeMenuDisclosure(),this.closeSearchModal()}reveal(){if(this.headerIsAlwaysSticky)return;this.header.classList.add('shopify-section-header-sticky','animate'),this.header.classList.remove('shopify-section-header-hidden')}reset(){if(this.headerIsAlwaysSticky)return;this.header.classList.remove('shopify-section-header-hidden','shopify-section-header-sticky','animate')}closeMenuDisclosure(){this.disclosures=this.disclosures||this.header.querySelectorAll('header-menu'),this.disclosures.forEach(e=>e.close())}closeSearchModal(){this.searchModal=this.searchModal||this.header.querySelector('details-modal');this.searchModal&&this.searchModal.close(!1)}}customElements.define('sticky-header',StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* Language dropdown toggle */
  document.addEventListener('DOMContentLoaded', function () {
    var langWrappers = document.querySelectorAll('.header-lang');

    langWrappers.forEach(function (wrap) {
      var toggle = wrap.querySelector('.header-lang__toggle');
      var list   = wrap.querySelector('.header-lang__list');

      if (!toggle || !list) return;

      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        wrap.classList.toggle('is-open');
        var expanded = wrap.classList.contains('is-open');
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });

      document.addEventListener('click', function (e) {
        if (!wrap.contains(e.target)) {
          wrap.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
